import { PcRestartResponse } from '@acorn-portal/shared/src/services/subscriptionAPI';

export interface IChangeUsageOrMileageForm {
	vehicleUse: string;
	levelOfCover: string;
	annualMileage: string;
	businessMileage?: string;
}

export const getUsageCoverDetails = (values: IChangeUsageOrMileageForm, quoteData: PcRestartResponse | undefined) => {
	const currentCover = quoteData?.quoteDetails.riskData.coverDetails;

	return {
		levelOfCover: values.levelOfCover || currentCover?.levelOfCover || '',
		effectiveFrom: currentCover?.effectiveFrom || new Date().toISOString(),
		voluntaryExcess: currentCover?.voluntaryExcess || 0,
		ncdRequirements: currentCover?.ncdRequirements || {
			protectedNcd: false,
			ncbYears: 0,
		},
	};
};
